// „Wo“ beim Öffnen des Schritts aus dem gewählten Risiko vorbelegen — für
// Schäden, deren Risiko schon feststeht (angelegt, aus der URL vorgewählt),
// ohne dass der Schritt „Risiko & Vertrag“ dafür besucht werden muss. Nur wenn
// Straße, PLZ und Ort noch leer sind; je Öffnen und Risiko höchstens einmal.
import * as React from "react";
import { apiUrl } from "../../../utils/api";
import type { BigAnswers } from "../../schadenmeldung-big/types";
import { risikoAnschrift, woVorbelegung } from "./vorbelegung";

export function useWoAusRisiko(opts: {
  /** Nur im Wo-Schritt. */
  aktiv: boolean;
  risikoId: number | null;
  answers: BigAnswers;
  update: (patch: Partial<BigAnswers>) => void;
}): void {
  const { aktiv, risikoId } = opts;
  const ref = React.useRef(opts);
  React.useEffect(() => {
    ref.current = opts;
  });
  React.useEffect(() => {
    if (!aktiv || risikoId === null) return;
    // Schon etwas eingetragen (oder Kfz): nichts zu tun, kein Abruf.
    if (woVorbelegung(ref.current.answers, { strasse: "?", plz: "?", ort: "?" }) === null) return;
    let abgebrochen = false;
    fetch(apiUrl(`risk-objects/${risikoId}`))
      .then((res) => (res.ok ? res.json() : null))
      .then((row) => {
        if (abgebrochen || !row) return;
        // Gegen den Stand von jetzt prüfen: inzwischen Getipptes bleibt stehen.
        const patch = woVorbelegung(ref.current.answers, risikoAnschrift(row));
        if (patch) ref.current.update(patch);
      })
      .catch(() => undefined);
    return () => {
      abgebrochen = true;
    };
  }, [aktiv, risikoId]);
}
